function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function cleanText(value) {
  return String(value || '').trim();
}

export function selectKeywordConflictState(state = {}) {
  const fromResult = asArray(state.keywordConflictResult?.conflicts || state.keywordConflictResult?.items || state.keywordConflictResult?.risks);
  const fromLegacy = asArray(state.lastDetectedConflicts);
  const fromJob = asArray(state.batchJob?.keywordConflicts);
  const conflicts = fromResult.length ? fromResult : fromLegacy.length ? fromLegacy : fromJob;
  return {
    conflictResult: state.keywordConflictResult || (conflicts.length ? { conflicts } : null),
    conflicts,
  };
}

export function selectListingDraftState(state = {}) {
  const title = state.listingDraftTitle || null;
  const bullets = state.listingDraftBullets || null;
  const description = state.listingDraftDescription || null;
  const searchTerms = state.listingDraftSearchTerms || null;
  const qa = asArray(state.listingDraftQa);

  return {
    title,
    bullets: asArray(bullets?.bulletsEn),
    description,
    searchTerms: cleanText(searchTerms?.searchTermsEn || searchTerms?.searchTerms),
    qa,
    keywordLibrary: state.keywordLibrary || null,
    businessContext: state.businessContext || null,
    selectedStKeywords: state.selectedStKeywords instanceof Set
      ? [...state.selectedStKeywords]
      : asArray(state.selectedStKeywords),
    complianceResult: state.complianceResult || null,
    scoringReport: state.scoringReport || null,
    revisionSuggestions: asArray(state.revisionSuggestions),
    revisionOverview: state.revisionOverview || null,
    revisionSuggestionsError: cleanText(state.revisionSuggestionsError),
  };
}
